<template>
  <div class="dashboard">
    <TabView :tabs="tabs">
      <template #store>
        <PerformancesWithLines :role="USER_ROLES.STORE_MANAGER"
      /></template>
      <template #ca>
        <PerformancesWithPie :role="USER_ROLES.STORE_MANAGER"
      /></template>
    </TabView>
  </div>
</template>
<script>
import PerformancesWithLines from "@/components/dashboard/PerformancesWithLines.vue";
import PerformancesWithPie from "@/components/dashboard/PerformancesWithPie.vue";
import TabView from "@/components/common/TabView.vue";
import { USER_ROLES } from "@/consts";
import normalPage from "@/mixins/normal-page";

export default {
  mixins: [normalPage],
  components: {
    TabView,
    PerformancesWithLines,
    PerformancesWithPie,
  },
  data() {
    return {
      USER_ROLES,
      tabs: [
        {
          key: "store",
          label: "店铺业绩",
        },
        {
          key: "ca",
          label: "CA业绩",
        },
      ],
    };
  },
};
</script>
<style lang="less">
.dashboard {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  border-top: solid 2px #f2f2f2;
}
</style>
